import React from 'react';

/*
 * Heritage Dahlias' Cropasaurus Rex tortoise mark.
 * Uses the original brand PNG (green pill + dino + amber egg) for every
 * variant — this is the only place the dino artwork lives.
 *
 * size: pixel width. height auto-scales 1:1.
 * variant kept for API back-compat (no behavioural difference now).
 */
export default function RexLogo({ size = 80, className = '' }) {
  return (
    <img
      src="/assets/rex-logo.png"
      alt="Cropasaurus Rex"
      width={size}
      height={size}
      className={className}
      style={{ display: 'block', width: size, height: 'auto', maxWidth: '100%' }}
      draggable={false}
    />
  );
}
